/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The orientation of the pump.
 */
export const AnimaticPumpConfigOrientation = {
  Horizontal: "horizontal",
  Vertical: "vertical",
} as const;
/**
 * The orientation of the pump.
 */
export type AnimaticPumpConfigOrientation = OpenEnum<
  typeof AnimaticPumpConfigOrientation
>;

/**
 * The configuration of the animatic for a pump.
 */
export type AnimaticPumpConfig = {
  /**
   * Whether to flip the orientation of the pump.
   */
  flip?: boolean | undefined;
  /**
   * The orientation of the pump.
   */
  orientation?: AnimaticPumpConfigOrientation | undefined;
};

/** @internal */
export const AnimaticPumpConfigOrientation$inboundSchema: z.ZodType<
  AnimaticPumpConfigOrientation,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticPumpConfigOrientation);
/** @internal */
export const AnimaticPumpConfigOrientation$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticPumpConfigOrientation
> = openEnums.outboundSchema(AnimaticPumpConfigOrientation);

/** @internal */
export const AnimaticPumpConfig$inboundSchema: z.ZodType<
  AnimaticPumpConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  flip: types.boolean().default(false),
  orientation: AnimaticPumpConfigOrientation$inboundSchema.default(
    "horizontal",
  ),
});
/** @internal */
export type AnimaticPumpConfig$Outbound = {
  flip: boolean;
  orientation: string;
};

/** @internal */
export const AnimaticPumpConfig$outboundSchema: z.ZodType<
  AnimaticPumpConfig$Outbound,
  z.ZodTypeDef,
  AnimaticPumpConfig
> = z.object({
  flip: z.boolean().default(false),
  orientation: AnimaticPumpConfigOrientation$outboundSchema.default(
    "horizontal",
  ),
});

export function animaticPumpConfigToJSON(
  animaticPumpConfig: AnimaticPumpConfig,
): string {
  return JSON.stringify(
    AnimaticPumpConfig$outboundSchema.parse(animaticPumpConfig),
  );
}
export function animaticPumpConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticPumpConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticPumpConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticPumpConfig' from JSON`,
  );
}
